import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getData } from "../../services/FetchNodeServices";

const ITEMS_PER_PAGE = 10;

const AllProductEnquiry = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1 });
  const [loading, setLoading] = useState(false);

  const fetchEnquiries = async (page = 1) => {
    try {
      setLoading(true);
      const res = await getData(`cardEnquiry/get-all-card-enquiry?limit=${ITEMS_PER_PAGE}&page=${page}`);

      if (res?.status) {
        setData(res.data || []);
        // console.log("totalPagestotalPages:==>", res);
        setPagination({
          currentPage: res.pagination.currentPage,
          totalPages: res.pagination.totalPages || 1, // backend should send totalPages
        });
      } else {
        toast.error("Failed to fetch enquiries.");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Something went wrong while fetching enquiries.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEnquiries(1);
  }, []);

  const handlePageChange = (page) => {
    if (page < 1 || page > pagination.totalPages) return;
    fetchEnquiries(page);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this enquiry?")) return;

    try {
      const res = await getData(`cardEnquiry/delete-card-enquiry/${id}`);
      if (res?.status) {
        toast.success("Enquiry deleted successfully.");
        fetchEnquiries(pagination.currentPage);
      } else {
        toast.error("Failed to delete enquiry.");
      }
    } catch (err) {
      toast.error("Server error while deleting.");
    }
  };

  const formatMessage = (msg) => {
    try {
      if (msg?.type === "Buffer" && Array.isArray(msg.data)) {
        return new TextDecoder().decode(new Uint8Array(msg.data));
      }
      return typeof msg === "string" ? msg : JSON.stringify(msg);
    } catch {
      return "—";
    }
  };

  const parseProduct = (productString) => {
    try {
      const parsed = JSON.parse(JSON.parse(productString));
      return parsed?.map((p, i) => (
        <div key={i}>
          <strong>{p.product?.name || "N/A"}</strong> (Qty: {p.quantity})
        </div>
      ));
    } catch {
      return <span>Invalid product data</span>;
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date) ? "—" : date.toLocaleDateString("en-IN");
  };

  const renderPaginationButtons = () => {
    const { currentPage, totalPages } = pagination;
    const pages = [];
    const pagesToShow = 3;

    if (totalPages > 0) pages.push(1);
    if (currentPage > pagesToShow + 2) pages.push("...");

    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);

    for (let i = startPage; i <= endPage; i++) {
      if (i > 1 && i < totalPages) {
        pages.push(i);
      }
    }

    if (currentPage < totalPages - (pagesToShow + 1)) pages.push("...");
    if (totalPages > 1) pages.push(totalPages);

    return (
      <div className="d-flex justify-content-center mt-3 gap-2 flex-wrap">
        <button
          className="btn btn-sm btn-outline-dark"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {pages.map((page, index) =>
          page === "..." ? (
            <span key={`ellipsis-${index}`} className="px-2">...</span>
          ) : (
            <button
              key={page}
              className={`btn btn-sm ${currentPage === page ? "btn-dark" : "btn-outline-dark"}`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          )
        )}

        <button
          className="btn btn-sm btn-outline-dark"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <>
      <ToastContainer />
      <div className="bread">
        <div className="head">
          <h4>All Product Enquiries</h4>
        </div>
      </div>

      <section className="d-table">
        <div className="table-responsive">
          <table className="table table-bordered table-striped table-hover">
            <thead className="table-dark">
              <tr>
                <th>Sr. No.</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Message</th>
                <th>Product</th>
                <th>Total Price</th>
                <th>Date</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="text-center">Loading...</td>
                </tr>
              ) : data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.id || index}>
                    <td>{(pagination.currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                    <td>{item.name || "—"}</td>
                    <td>{item.email || "—"}</td>
                    <td>{item.phone || "—"}</td>
                    <td style={{ whiteSpace: "pre-line", maxWidth: 250 }}>
                      {formatMessage(item.message)}
                    </td>
                    <td style={{ maxWidth: 250 }}>{parseProduct(item.product)}</td>
                    <td>{item.totalPrice}</td>
                    <td>{formatDate(item.create_date)}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(item.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No enquiries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {pagination.totalPages > 1 && renderPaginationButtons()}
      </section>
    </>
  );
};

export default AllProductEnquiry;
